import apiFetch from 'utils/apiFetch';

export function saveCardAction(actionType, cardType, contentId = 0) {
  return apiFetch(
    'POST',
    { endPoint: 'saveCardAction' },
    { actionType, cardType, contentId },
  );
}

export function getComments(cardType, cardId = 0) {
  return apiFetch(
    'GET',
    { endPoint: 'getComments' },
    { cardType, cardId },
  );
}

export function sendComment(newComment, cardType, cardId = 0) {
  return apiFetch(
    'POST',
    { endPoint: 'sendComment' },
    { newComment, cardType, cardId },
  );
}



// WEBPACK FOOTER //
// ./src/components/Steps/CustomCard/modules/actions.js